'use client';

import React from 'react';
import Link from 'next/link';
import { useTranslation } from '@/i18n';

type Crumb = { label: string; href?: string };

export default function PublicHero(props: {
  title: string;
  subtitle?: string | null;
  crumbs?: Crumb[];
}) {
  const { locale } = useTranslation();
  const defaultHome = locale === 'ar' ? 'الرئيسية' : 'Home';
  const defaultLabel = locale === 'ar' ? 'بروفلو 360' : 'ProFlow 360';
  const crumbs = props.crumbs && props.crumbs.length > 0 ? props.crumbs : [{ label: defaultHome, href: '/' }, { label: props.title }];

  return (
    <section className="relative pt-24 pb-12 bg-gradient-to-r from-[#081a3a] via-[#0a2b5a] to-[#081a3a]">
      <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_20%_20%,rgba(245,158,11,0.25),transparent_40%),radial-gradient(circle_at_80%_30%,rgba(59,130,246,0.18),transparent_45%)]" />
      <div className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 text-xs text-white/70">
          {crumbs.map((c, i) => (
            <React.Fragment key={`${c.label}-${i}`}>
              {i > 0 && <span className="opacity-50">/</span>}
              {c.href ? (
                <Link href={c.href} className="hover:text-white transition-colors">
                  {c.label}
                </Link>
              ) : (
                <span className="text-white/80">{c.label}</span>
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="mt-4 max-w-3xl">
          <p className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-amber-300">
            <span className="w-8 h-px bg-amber-300/80" />
            {defaultLabel}
          </p>
          <h1 className="mt-3 text-3xl sm:text-4xl font-bold text-white tracking-tight">
            {props.title}
          </h1>
          {props.subtitle ? (
            <p className="mt-3 text-base sm:text-lg text-white/75 leading-relaxed">
              {props.subtitle}
            </p>
          ) : null}
        </div>
      </div>
    </section>
  );
}
